import { useSearchParams } from 'react-router-dom';
import type { ComposeKind } from '../compose/ComposeModal.js';

interface Props {
  kind: ComposeKind;
  id: string;
  /** ボタン表示テキスト。未指定時は「編集」 */
  label?: string;
  /** ボタンサイズ。MyPage 行は xs、詳細ページは sm 推奨 */
  size?: 'xs' | 'sm';
}

/**
 * 自分の投稿を編集する導線。クリックで `?compose=<kind>&edit=<id>` をクエリに付与し
 * ComposeModal を編集モードで開く。Rules の `ownerOf(resource.data)` で本人のみ
 * update が通るため、表示自体も呼出元で owner 判定したうえで描画する想定。
 */
export function EditOwnButton({ kind, id, label = '編集', size = 'xs' }: Props) {
  const [params, setParams] = useSearchParams();

  const open = () => {
    const next = new URLSearchParams(params);
    next.set('compose', kind);
    next.set('edit', id);
    setParams(next);
  };

  return (
    <button
      type="button"
      className={`btn ${size}`}
      onClick={open}
      aria-label={`${label}（${kind}）`}
    >
      {label}
    </button>
  );
}
